<template>
  <fragment>
    <c-generic-section>
      <div class="container-xs article">
        <p v-if="loading" class="article-status">
          Loading&hellip;
          <span class="article-zh">加载中</span>
        </p>

        <template v-else-if="loadFailed">
          <p class="article-status">
            This article could not be loaded. It may have been moved or removed.
            <span class="article-zh">文章加载失败,可能已被移动或删除</span>
          </p>
          <p class="article-status">
            <router-link :to="backLink" class="article-back">&larr; {{ backLabel }}</router-link>
          </p>
        </template>

        <template v-else>
          <router-link :to="backLink" class="article-back">&larr; {{ backLabel }}</router-link>
          <h2 class="article-title">{{ title }}</h2>
          <p v-if="publishDate" class="article-date text-color-low">{{ publishDate }}</p>
          <div class="article-body" v-html="content"></div>
        </template>
      </div>
    </c-generic-section>

    <c-cta top-divider bottom-divider split />
  </fragment>
</template>

<script>
// import layout
import CLayout from '@/layouts/LayoutDefault.vue'
// import sections
import CGenericSection from '@/components/sections/GenericSection.vue'
import CCta from '@/components/sections/Cta.vue'
import marked from 'marked'

export default {
  name: 'ArticleDetail',
  components: {
    CGenericSection,
    CCta
  },
  data() {
    return {
      title: '',
      content: '',
      publishDate: '',
      loading: true,
      loadFailed: false
    }
  },
  computed: {
    // The listing passes its mode along as ?type=N|H so the back link can
    // return to the right list.
    listType: function () {
      return this.$route.query.type === 'H' ? 'H' : 'N'
    },
    backLink: function () {
      return { path: '/document', query: { type: this.listType } }
    },
    backLabel: function () {
      return this.listType === 'H'
        ? 'Back to Documentation 返回资料列表'
        : 'Back to News 返回新闻列表'
    }
  },
  created() {
    this.$emit('update:layout', CLayout)
    this.loadEntry()
  },
  watch: {
    $route() {
      this.loadEntry()
    }
  },
  methods: {
    loadEntry: function () {
      var query = this.$route.query
      var id = query.id
      var tag = query.tag
      this.loading = true
      this.loadFailed = false
      if (!id || !tag) {
        this.loading = false
        this.loadFailed = true
        return
      }
      this.$axios
        .get(
          'https://cdn.contentful.com/spaces/' +
            tag +
            '/environments/master/entries/' +
            id +
            '?access_token=wVryCvO_gFJfPY34V4KTn9gDxZeEa3lNWHkra043a7c'
        )
        .then((res) => {
          this.loading = false
          if (res.data != null && res.data.fields) {
            this.title = res.data.fields.title
            this.content = marked(res.data.fields.markdown || '')
            this.publishDate = this.formatDate(
              res.data.sys && res.data.sys.createdAt
            )
            document.title = this.title + ' — Line-1 Logistics'
          } else {
            this.loadFailed = true
          }
        })
        .catch(() => {
          this.loading = false
          this.loadFailed = true
        })
    },
    formatDate: function (value) {
      if (!value) {
        return ''
      }
      var date = new Date(value)
      if (isNaN(date.getTime())) {
        return ''
      }
      var month = date.getMonth() + 1
      var day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    }
  }
}
</script>

<style scoped>
.article {
    text-align: left;
}
.article-status {
    text-align: center;
    margin: 32px 0;
}
.article-zh {
    display: block;
    font-size: 13px;
    opacity: .7;
    margin-top: 6px;
}
.article-back {
    display: inline-block;
    font-size: 14px;
    color: #1D5FC2;
    text-decoration: none;
    margin-bottom: 24px;
}
.article-back:hover {
    text-decoration: underline;
}
.article-title {
    margin-top: 0;
    margin-bottom: 8px;
}
.article-date {
    font-size: 14px;
    margin-bottom: 32px;
}
/* Prose rendered from Contentful markdown via v-html needs deep selectors,
   since scoped attributes are not applied to injected markup. */
.article-body >>> img {
    max-width: 100%;
    height: auto;
}
.article-body >>> p {
    margin: 0 0 16px;
}
.article-body >>> h1,
.article-body >>> h2,
.article-body >>> h3,
.article-body >>> h4 {
    margin: 32px 0 12px;
}
.article-body >>> ul,
.article-body >>> ol {
    margin: 0 0 16px;
    padding-left: 24px;
}
.article-body >>> blockquote {
    border-left: 3px solid #E3EDFB;
    margin: 0 0 16px;
    padding-left: 16px;
}
.article-body >>> table {
    max-width: 100%;
}
</style>
